import { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { APPROVALS, PHASES, truncate } from "../../seo/explore-data";
import { PageSeo, Crumbs, CtaBlock, Disclaimer } from "./ExploreBits";

export default function ApprovalsIndex() {
  const [q, setQ] = useState("");
  const needle = q.trim().toLowerCase();
  const match = (a) => !needle || `${a.name} ${a.plain_summary || ""} ${a.authority || ""}`.toLowerCase().includes(needle);
  const groups = PHASES.map((p) => ({ ...p, items: APPROVALS.filter((a) => a.phase === p.key && match(a)) }));
  const other = APPROVALS.filter((a) => !PHASES.some((p) => p.key === a.phase) && match(a));
  if (other.length) groups.push({ key: "other", code: "", label: "Other approvals", items: other });

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="approvals-index-page">
      <PageSeo title="Browse All Power Project Approvals & Clearances in India | RegNav"
        description={`Plain-language guides to all ${APPROVALS.length} statutory and regulatory approvals for Indian power, solar, wind, BESS and transmission projects.`}
        path="/approvals/" />
      <Crumbs items={[{ name: "Home", to: "/" }, { name: "Approvals" }]} />
      <h1 className="font-serif text-3xl sm:text-4xl text-[#0B1F3A]">Every approval &amp; clearance for Indian power projects</h1>
      <p className="text-sm text-[#475569] mt-3 max-w-2xl">Plain-language guides to all {APPROVALS.length} statutory and regulatory approvals — documents, timelines, authorities and process, expert-verified by Solarian.</p>
      <div className="relative mt-6 max-w-md">
        <Search size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#475569]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search approvals — e.g., GNA, CEIG, forest, railway…"
          className="w-full pl-10 pr-4 py-3 bg-white border border-[#0B1F3A]/20 rounded-lg text-sm focus:ring-2 focus:ring-[#059669] focus:outline-none" data-testid="approvals-search-input" />
      </div>
      {groups.filter((g) => g.items.length).map((g) => (
        <section key={g.key} className="mt-9">
          <h2 className="font-serif text-xl text-[#0B1F3A] mb-4">{g.code ? `${g.code} · ` : ""}{g.label}</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {g.items.map((a) => (
              <Link key={a.key} to={`/approvals/${a.slug}`} className="block bg-white border border-[#0B1F3A]/10 rounded-xl px-5 py-4 card-lift" data-testid={`approval-card-${a.key}`}>
                <h3 className="font-serif font-semibold text-[#0B1F3A]">{a.name}</h3>
                <p className="text-xs text-[#475569] mt-1.5">{truncate(a.plain_summary, 130)}</p>
                <p className="text-[11px] text-[#475569] mt-2">~{a.timeline_days || "—"} days · {a.department || ""}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
      {!groups.some((g) => g.items.length) && <p className="text-sm text-[#475569] mt-8">No approvals match "{q}".</p>}
      <CtaBlock />
      <Disclaimer />
    </div>
  );
}
